// Twoje konta (paczka 12, artboardy 01–04). Klucze trzymaj zgodne z en/appAccounts.ts.
//
// ŻADNEJ NAZWY DOSTAWCY ANI POJĘCIA POŚREDNIKA W TEKŚCIE WIDZIANYM PRZEZ KLIENTA —
// pilnuje `__tests__/locales-no-intermediary`. Nazwa protokołu logowania też nie pada:
// mówimy „oficjalne logowanie”, a platforma jest słowem PRZY koncie, nie w nagłówku.
export const appAccounts = {
  // Tytułem ekranu jest „Publikacja” (rama pięciu zakładek, sesja 35), a zakładka nazywa
  // się „Konta”. Ten klucz zostaje nazwą widoku dla czytnika ekranu i dla dawnych testów;
  // zdanie wstępu zniknęło z ekranu (zasada 8) — to samo mówi jedyne zdanie okna platform.
  title: 'Twoje konta',
  // Reguła 24: stan CAŁEJ funkcji jako pigułka w wierszu tytułu, małą literą.
  feature: {
    paused: 'publikowanie wstrzymane',
  },
  // Pigułka wiersza, w którym dzienny limit konta jest już wyczerpany.
  limitPill: 'limit na dziś',

  platform: {
    tiktok: 'TikTok',
    instagram: 'Instagram',
    youtube: 'YouTube',
  },
  // Miejscownik nazwy platformy - polszczyzna odmienia „na TikToku / Instagramie /
  // YouTube”, więc zdania mówiące „zostają na …” biorą TĘ formę, a nie mianownik
  // z `platform.*` (MAPA 23, decyzja 13).
  platformLoc: {
    tiktok: 'TikToku',
    instagram: 'Instagramie',
    youtube: 'YouTube',
  },
  // Dopełniacz nazwy platformy - „dzienny limit TikToka / Instagrama / YouTube”; mianownik
  // z `platform.*` jest w tej pozycji niepoprawny.
  platformGen: {
    tiktok: 'TikToka',
    instagram: 'Instagrama',
    youtube: 'YouTube',
  },
  // Wybór platformy przed logowaniem (artboard 01): jedno zdanie o tym, czego platforma
  // wymaga, i jedno o tym, czym stanie się edit. Liczby sekund i minut wyłącznie te,
  // które platformy naprawdę egzekwują.
  // REGUŁA 32 (Domi, 20.09): karta platformy to glif + nazwa + akcja „Połącz”. Żadnych
  // opisów możliwości, limitów długości ani formatów; JEDYNY tekst pod nazwą ma Instagram,
  // bo tam naprawdę nadaje się tylko szczególny rodzaj konta. Klucze, które umarły razem
  // z tą regułą: `tiktok.req`, `tiktok.fmt`, `instagram.fmt`, `youtube.req`, `youtube.fmt`,
  // `password`, `next` (kafel ma własną akcję, okno ma tylko „Anuluj”).
  platformDialog: {
    title: 'Którą platformę podłączasz?',
    // Jedyne zdanie okna: wymóg prawny, nie opis możliwości.
    official: 'Podłącz konto przez oficjalne logowanie. Publikujemy tylko to, co zatwierdzisz.',
    instagram: {
      req: 'Konto firmowe lub konto twórcy.',
    },
    connect: 'Połącz',
    cancel: 'Anuluj',
  },
  // Etykieta kafla Pulpitu (artboard 15): „Twoje konta”.
  stats: {
    connectedLabel: 'Twoje konta',
  },
  status: {
    connected: 'aktywne',
    disconnected: 'rozłączone',
    expired: 'zaloguj ponownie',
    // NIE „uśpione”: konto wypadło poza sloty planu (`reason.connection_suspended`).
    suspended: 'poza planem',
  },
  action: {
    reconnect: 'Połącz ponownie',
    disconnect: 'Odłącz',
  },
  slots: {
    label: 'Sloty w Twoim planie',
    buy: 'Dokup slot',
    full: 'Wszystkie sloty są przypisane w tym okresie',
    // Pigułka wiersza, w którym slot wciąż trzyma tożsamość spoza listy. Zdanie o tym,
    // do kiedy slot zostaje przypisany, wyleciało z ekranu (reguła 32) i żyje dalej
    // w Regulaminie i w FAQ (`faq.ts`, pytanie o sloty) - tam jest jego miejsce.
    heldPill: 'slot zajęty',
    // Ile postów czeka na rozliczenie ręczne (`needs_manual_settlement`). Pigułka przy
    // mierze slotów: fakt jest TRWAŁY (tokeny wstrzymane), więc nie może wisieć na
    // jednorazowym toaście po odłączeniu konta.
    settlementPill: 'rozliczenie ręczne · {n}',
  },
  // Odłączenie konta. Obie konsekwencje z liczbami z backendu, PRZED kliknięciem.
  disconnect: {
    title: 'Odłączyć {handle}?',
    body: 'EDIMI straci dostęp do publikowania na tym koncie. Opublikowane posty zostają na {platformLoc}.',
    // Dwie etykiety okna sprzed redesignu. Z ekranu Kont znikły (jedno zdanie z liczbą,
    // 09b), ale woła je jeszcze ławka podglądu `routes/a25/p06States.tsx`.
    willCancel: 'Zaplanowane posty zostaną anulowane',
    willRefund: 'Tokeny wrócą do Twojej puli',
    // JEDNO zdanie okna, z liczbą z backendu (09b). Wołać przez `_` + pluralForm().
    willCancelCount: '{n} zaplanowanych postów zostanie anulowanych.',
    willCancelCount_one: '{n} zaplanowany post zostanie anulowany.',
    willCancelCount_few: '{n} zaplanowane posty zostaną anulowane.',
    willCancelCount_many: '{n} zaplanowanych postów zostanie anulowanych.',
    keep: 'Zostaw',
    toast: 'Odłączono {handle} · zwrócono {n} tokenów',
    toast_one: 'Odłączono {handle} · zwrócono {n} token',
    toast_few: 'Odłączono {handle} · zwrócono {n} tokeny',
    toast_many: 'Odłączono {handle} · zwrócono {n} tokenów',
  },
  // Zdanie o wygasłej autoryzacji wyleciało przez zasadę 8: mówi to pigułka „zaloguj
  // ponownie” przy koncie i droga naprawy „Połącz ponownie” obok niej. To samo spotkało
  // zdania okna „publikowanie chwilowo nie działa” — stan CAŁEJ funkcji jest dziś pigułką
  // przy tytule (reguła 24). Noty `settlementNote_*` też wypadły, ale ich FAKT nie:
  // niesie go pigułka `slots.settlementPill` przy mierze slotów.
  error: {
    identityMismatch: 'Wybrano inne konto niż przypisane do slotu. Dalsze próby są wstrzymane do końca okresu. Skontaktuj się z nami, jeśli to pomyłka.',
    connectionPending: 'Poprzednie logowanie jest jeszcze w toku. Dokończ je albo spróbuj ponownie za 15 minut.',
    // Droga powrotu z okna błędu Planera (`routes/Campaigns.tsx`, terytorium paczki 35a).
    back: 'Wróć do Twoich kont',
    // Punkt 41 sesji 35: „pobrać” znaczy w tym produkcie ściągnięcie pliku.
    title: 'Nie udało się wczytać kont.',
    retry: 'Spróbuj ponownie',
    // Powrót z okna Google bez kanału (artboard 02): to nie awaria, tylko wybrane konto
    // Google, na którym kanału nie ma. Pasek pod paskiem tytułu, nie toast - artysta
    // wraca z zewnętrznego okna i musi to przeczytać bez pośpiechu.
    youtubeNoChannel: 'To konto Google nie ma kanału. Zacznij od nowa i wybierz w oknie Google konto z kanałem.',
    // Every other failed return: the vendor named no cause, so neither do we.
    connectFailed: 'Nie udało się podłączyć konta. Spróbuj ponownie.',
  },
  // Stan „publikowanie chwilowo nie działa” jest na ekranie Kont pigułką (reguła 24),
  // ale to samo zdanie niesie jeszcze Planer (`routes/Campaigns.tsx`, paczka 35a).
  unavailable: {
    title: 'Publikowanie chwilowo nie działa',
    body: 'Twoje kampanie są bezpieczne, a zaplanowane posty czekają. Wznowimy je automatycznie.',
  },
  toolbar: {
    connect: 'Podłącz konto',
    // Stan zajęty przycisku głównego, gdy otwieramy okno logowania platformy (09h).
    connecting: 'Otwieramy logowanie…',
  },
  // Pusty stan (09e): glif, tytuł, JEDNA akcja. Bez drugiego zdania (zasada 8); miara
  // slotów zostaje nad nim, bo to ona mówi, ile kont w ogóle da się podłączyć.
  empty: {
    title: 'Brak podłączonych kont',
  },
  table: {
    thToday: 'Dziś',
    // Limit dzienny jako KOLUMNA wiersza (klatka 08a): „dziś 2/5”, nie zdanie o limicie.
    // Własny klucz, bo `appCampaigns.detail.limitToday` należy do Planera i mówi „0 / 5 dziś”.
    todayOf: 'dziś {n}/{max}',
    // Nazwa akcji odświeżenia listy: na ekranie stoi jako sam glif 44 px (reguła 32),
    // więc ten tekst jest wyłącznie dla czytnika ekranu.
    refresh: 'Odśwież listę',
  },
  // 45-B, paczka PK — arkusz „Zaawansowane: @konto” (erratum A.1: ustawienia publikacji RAZ na koncie,
  // Regulamin §10.p5). Dwa bloki bez nagłówków-zdań: Publikacja i Limity (reguła 8, zero objaśnień).
  advanced: {
    title: 'Zaawansowane: {handle}',
    // Pigułka `warn` w wierszu konta (Konta) i w kroku Konta Planera (reguły 5 / 24).
    noSettings: 'bez ustawień publikacji',
    visibility: 'Widoczność',
    comment: 'Komentarze',
    duet: 'Duet',
    stitch: 'Stitch',
    brand: 'Marka',
    brandOrganic: 'Twoja marka',
    brandContent: 'Płatna współpraca',
    kids: 'Dla dzieci',
    yes: 'Tak',
    no: 'Nie',
    yt: {
      public: 'Publiczny',
      unlisted: 'Niepubliczny',
      private: 'Prywatny',
    },
    maxPerDay: 'Postów dziennie',
    hours: 'Godziny',
    // Czytnik: dwa steppery godzin mają nazwy „od” / „do”.
    from: 'Od',
    to: 'Do',
    gap: 'Odstęp',
    gapValue: '{n} h',
    ownSchedule: 'Własny harmonogram',
    week: 'Tydzień',
    less: 'Mniej: {label}',
    more: 'Więcej: {label}',
    save: 'Zapisz',
    saved: 'Zapisano ustawienia {handle}.',
    saveFailed: 'Nie udało się zapisać ustawień.',
    loadFailed: 'Nie udało się wczytać ustawień.',
    retry: 'Ponów',
    // TikTok nie oddał opcji widoczności i nie ma kopii: pigułka w wierszu widoczności (PK-8);
    // pełny powód tylko dla czytnika.
    noOptions: 'brak opcji',
    noOptionsReason: 'Nie udało się wczytać opcji widoczności z TikToka.',
    back: 'Wróć do listy',
  },
}
